import React from "react";
import { FaShoppingBasket } from "react-icons/fa";
import { MdEdit, MdLibraryAdd, MdDelete } from "react-icons/md";
import parse from "html-react-parser";
import { Spinner } from "react-rainbow-components";
import ModalCreateProduct from "../../components/productSettingComponent/ModalCreateProduct";
import ModalEditProduct from "../../components/productSettingComponent/ModalEditProduct";
import { IProduct } from "../../interfaces/product";
import {
  BubleEdit,
  CardContent,
  CardProduct,
  Container,
  Descriptions,
  HeaderTitleCard,
  HeaderTitle,
  ReadMoreButton,
  TypeProduct,
  Detail,
  CardContainer,
} from "./index.style";
import ModalConfirmation from "../../components/common/ModalConfirmation";
import { deleteProduct, getProduct } from "../../services/product.service";
import { useError } from "../../store/ErrorModal";
import { GetErrorMessage } from "../../functions/error";

const CardAddProduct = ({ onClick }: { onClick: () => void }) => (
  <CardProduct style={{ padding: 0 }}>
    <CardContainer onClick={onClick}>
      <h1 style={{ color: "#DDD" }}>เพิ่ม</h1>
      <MdLibraryAdd size={100} color="#DDD" />
      <h5 style={{ color: "#DDD", paddingTop: "1rem" }}>สินค้า</h5>
    </CardContainer>
  </CardProduct>
);

const CardProductComponent = ({
  item,
  fetchData,
}: {
  item: IProduct;
  fetchData: () => void;
}) => {
  const [showMore, setShowMore] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isOpenDelete, setIsOpenDelete] = React.useState<boolean>(false);
  const { onError } = useError();
  const handleDelete = async () => {
    try {
      await deleteProduct(item.productId);
      setIsOpenDelete(false);
      fetchData();
    } catch (error) {
      onError(GetErrorMessage(error));
    }
  };
  return (
    <CardProduct bgImage={item.imageUrl}>
      <BubleEdit onClick={() => setIsOpen(true)}>
        <MdEdit size={22} color="#555" />
      </BubleEdit>
      {item.type === "product" && (
        <BubleEdit
          style={{ right: "3.25rem" }}
          onClick={() => setIsOpenDelete(true)}
        >
          <MdDelete size={22} color="#555" />
        </BubleEdit>
      )}
      <TypeProduct>
        {item.type[0].toUpperCase() + item.type.slice(1)}
      </TypeProduct>
      <CardContent>
        <HeaderTitleCard showMore={showMore}>
          {item.productName}
        </HeaderTitleCard>
        <Descriptions showMore={showMore}>
          {parse(item.productDescription || "")}
        </Descriptions>
        <ReadMoreButton onClick={() => setShowMore(!showMore)}>
          {showMore ? "ยุบลง" : "เพิ่มเติม"}
        </ReadMoreButton>
        <Detail>
          <span>ราคา:</span> {item.price} บาท{"  "}
          {item.type === "product" ? (
            <>
              <span>จำนวนคงเหลือ:</span> {item.amount} ชิ้น
            </>
          ) : item.type === "chat" ? (
            <>
              {item.timeRange && (
                <>
                  <span>ระยะเวลา:</span> {item.timeRange / 1440} วัน
                </>
              )}
            </>
          ) : (
            <>
              {item.timeRange && (
                <>
                  <span>ระยะเวลา:</span> {item.timeRange} นาที
                </>
              )}
            </>
          )}
        </Detail>
      </CardContent>
      <ModalEditProduct
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        fetchData={() => {}}
        oldData={item}
      />
      <ModalConfirmation
        isOpen={isOpenDelete}
        onConfirm={handleDelete}
        onCancel={() => setIsOpenDelete(false)}
        title={"ยืนยันการลบ"}
        description={`ยืนยันการลบ ${item.productName}`}
      />
    </CardProduct>
  );
};

function ProductSettingPage() {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [data, setData] = React.useState<IProduct[]>([]);
  const handalClickCreateProduct = () => setIsOpen(true);
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getProduct();
      setData(res.data);
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Container>
      {!isLoading ? (
        <>
          <ModalCreateProduct
            fetchData={fetchData}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
          <HeaderTitle style={{ width: "100%" }}>
            <FaShoppingBasket size="2rem" />
            <h1>จัดการโปรโมชั่นสินค้า</h1>
          </HeaderTitle>
          <CardAddProduct onClick={handalClickCreateProduct} />
          {data.map((item, index) => (
            <CardProductComponent
              fetchData={fetchData}
              item={item}
              key={index}
            />
          ))}
        </>
      ) : (
        <div>
          <Spinner size="large" variant="brand" />
        </div>
      )}
    </Container>
  );
}

export default ProductSettingPage;
